export const transition = {
  fast: "150ms cubic-bezier(0.65, 0, 0.28, 1)",
  default: "250ms cubic-bezier(0.65, 0, 0.28, 1)",
  slow: "500ms cubic-bezier(0.65, 0, 0.28, 1)",
};
